<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/vehicleAccess/add')">新增</el-button>

      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">

        <el-form-item prop="plateNumber" label="车牌号">
          <!-- <el-input v-model="searchForm.plateNumber" placeholder="请输入车牌号"></el-input> -->
          <el-select v-model="searchForm.plateNumber" clearable filterable placeholder="请选择车牌号">
            <el-option v-for="(item, index) of vehicleList" :value="item.plateNumber" :label="item.plateNumber"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="outTime" label="外出时间">
          <el-date-picker v-model="searchForm.outTime" placeholder="请选择外出时间" type="datetime" clearable
            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="returnTime" label="回厂时间">
          <el-date-picker v-model="searchForm.returnTime" placeholder="请选择回厂时间" type="datetime" clearable
            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="approveResult" label="审批结果">
          <el-select v-model="searchForm.approveResult" clearable filterable placeholder="请选择审批结果">
            <el-option v-for="(item, index) of resultArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="车牌号" prop="plateNumber"></el-table-column>
        <el-table-column min-width="120" label="外出时间" prop="outTime"></el-table-column>
        <el-table-column min-width="120" label="回厂时间" prop="returnTime"></el-table-column>
        <el-table-column min-width="120" label="司机姓名" prop="driver"></el-table-column>
        <el-table-column min-width="120" label="司机手机" prop="driverPhone"></el-table-column>
        <el-table-column min-width="120" label="外出原因" prop="reason"></el-table-column>

        <el-table-column min-width="120" label="审批结果" prop="approveResult">
          <template v-slot="{ row }">
            <el-tag type="success" v-if="row.approveResult == '1'">待审批</el-tag>
            <el-tag v-if="row.approveResult == '2'">审批通过</el-tag>
            <el-tag type="danger" v-if="row.approveResult == '3'">审批驳回</el-tag>

          </template>
        </el-table-column>
        <el-table-column min-width="160" label="创建人姓名" prop="createUserName"></el-table-column>

        <el-table-column width="220" label="操作" fixed="right">
          <template v-slot="{ row }">

            <el-button type="text" @click="
              $router.push('/vehicleAccess/detail?recordId=' + row.recordId)
              ">详情</el-button>
            <el-button type="text"  v-if="hasEdit&&row.approveResult == '1' "
              @click="$router.push('/vehicleAccess/edit?recordId=' + row.recordId)">编辑</el-button>
            <el-button type="text" @click="onApproval(row)"
              v-if="row.approveResult == '1' && hasApproval">审批</el-button>

            <el-button v-if="hasStop" type="text" @click="stopRow(row)" class="del-btn">结束</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.recordId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

    <!-- 审批 -->
    <ApprovalDialog urlType="5" :relatedId="rowId" v-if='showDlg' @closeDlg="showDlg = false" @successSave="loadData"
      :showDlg="showDlg"></ApprovalDialog>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import ApprovalDialog from '@/views/bondRecord/ApprovalDialog'

export default {
  name: 'vehicleAccess',
  mixins: [keepAlive],
  components: { ApprovalDialog },

  data() {
    return {
      tableData: [],

      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        status: '',
        plateNumber: ''

      },
      // 空闲/工作中/外出
      resultArr: [
        {
          label: '待审批',
          value: '1'
        },
        {
          label: '审批通过',
          value: '2'
        },
        {
          label: '审批驳回',
          value: '3'
        }

      ],
      specList: [],
      rowId: '',
      showDlg: false,
      vehicleList: []
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    },
    hasStop() {
      return this.buttonList.includes('stop')
    }
  },
  created() {
    this.loadDataVehicle()
    this.loadData()
  },

  methods: {
    loadDataVehicle() {
      this.$axios
        .get(this.$apis.vehicleManage.selectPaVehicleInfoByPage, {
        })
        .then(res => {
          this.vehicleList = res.list
        })
    },

    onApproval(row) {
      this.rowId = row.recordId
      this.showDlg = true
    },
    deleteRow(recordId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.vehicleAccess.deletePaVehicleOut, {
          recordId
        }).then(() => {
          this.loadData()
        })
      })
    },
    stopRow(row) {
      this.$confirm('确认结束吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.vehicleManage.updatePaVehicleInfo, {
          plateId: row.plateId,
          plateNumber: row.plateNumber,
          status: '1'
        }).then(() => {
          this.loadData()
        })
      })
    },

    loadData() {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.vehicleAccess.selectPaVehicleOutByPage, {
          params: params
        })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    }

  }
}
</script>
<style lang="scss" scoped></style>
